import { createAction, props } from '@ngrx/store';

import { ShiftDetailResponse } from '../models/shift-detail.model';
import { ShiftListSearchCriteria } from '../models/shift-list.model';

export const shiftAction = {
  shiftListRequest: createAction('[Shift] shift list request', props<{ payload: ShiftListSearchCriteria }>()),
  shiftListResponse: createAction('[Shift] shift list response', props<{ response: any }>()),
  viewShiftRequest: createAction('[Shift] shift detail request', props<{ docNo: string }>()),
  viewShiftResponse: createAction('[Shift] shift detail response', props<{ response: ShiftDetailResponse }>())
};
